import React from "react";

import { FormInputPropType } from "../type";

const FormUnkownInput = (config: FormInputPropType) => (
  <div>No configuration for {config.inputType}</div>
);

export default FormUnkownInput;
